$(document).ready(function() {
  const timerElement = document.querySelector('.time');
  const resendCodeElement = document.querySelector('.resend-code');
  const buttonSubmitOtp = document.querySelector('#submit-otp-code');
  const dataResendCode  = document.querySelector('#data-resend-code');
  const otpCodes        = document.querySelectorAll('.otp-codes');
  let timeRemaining = 60;

  if (timerElement) {
    function updateTimer() {
      const minutes = Math.floor(timeRemaining / 60);
      const seconds = timeRemaining % 60;

      timerElement.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      timeRemaining--;

      if (timeRemaining < 0) {
        clearInterval(timerInterval);
        var data_url    = '/user/resend_otp';
        var data_method = 'put';
        var data_class  = '';

        if (dataResendCode != null) {
          if (dataResendCode.dataset.url != undefined) {
            data_url = dataResendCode.dataset.url
          }

          if (dataResendCode.dataset.method != undefined) {
            data_method = dataResendCode.dataset.method
          }

          if (dataResendCode.dataset.class != undefined) {
            data_class = dataResendCode.dataset.class
          }
        }

        resendCodeElement.innerHTML = `<span class='text-neutral-80'>Didn’t receive code? </span><a href='#' class='fw-600 ${data_class}' id='resend-code-link'>Resend code</a>`;
        if (data_class.length >= 1) {
          reloadCurrentPage()
        }

        $('#resend-code-link').on('click', function(event) {
          event.preventDefault();
          $.ajax({
            url: data_url,
            type: data_method.toUpperCase(),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            error: function(error) {
              console.error('Error:', error);
            }
          });
        });
      }
    }

    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);
  }

  otpCodes.forEach(function(input) {
    input.type = 'number'
    input.setAttribute('onkeypress', "if ((/^[0-9]{1,1}$/.test(this.value))) return false;");
    input.setAttribute('pattern', "[0-9]*");
    input.addEventListener('keyup', filledOtpCode);
  })

  if (buttonSubmitOtp) {
    buttonSubmitOtp.addEventListener('click', filledOtpCode)
  }

  function filledOtpCode() {
    var otp_codes = ''

    document.querySelectorAll('.otp-codes').forEach(el => {
      if (el.length != 0) {
        otp_codes += el.value
      }
    })

    document.querySelector('#append-otp-code').value = otp_codes
  }

  var codeCharInput = '.otp-codes';
  $(codeCharInput+':first').focus();
  $(codeCharInput).keyup(function(e) {
    if ((e.which == 8 || e.which == 46)) {
      $(this).prev(codeCharInput).focus().val($(this).prev().val()).select();
    } else {
      if (/^[0-9\-]+$/i.test(this.value)) {
        if (this.value.length == this.maxLength) {
          $(this).next(codeCharInput).focus();
        }
      } else {
        this.value = ''
      }
    }
  });

  $(codeCharInput).on("click", function () {
    $(this).select();
  });

  function reloadCurrentPage() {
    $('.reload-current-page').click(function() {
      location.reload();
    })
  }
})
